import React from 'react'
import { Tag, Tooltip, Space } from 'antd'
import { WarningOutlined, PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons'
import { PackingAnomalies } from '../../types'

interface AnomalyBadgesProps {
  anomalies?: PackingAnomalies
  showCount?: boolean
}

/**
 * 装箱异常徽章组件
 * 显示缺件、超件、清单外录入的标识
 */
export const AnomalyBadges: React.FC<AnomalyBadgesProps> = ({ 
  anomalies, 
  showCount = true 
}) => {
  if (!anomalies) {
    return <span style={{ color: '#999' }}>-</span>
  }

  const { hasMissing, hasExtra, hasOffList, missingCount, extraCount, offListCount } = anomalies

  // 如果没有任何异常
  if (!hasMissing && !hasExtra && !hasOffList) {
    return <Tag color="success">正常</Tag>
  }

  return (
    <Space size={4}>
      {hasMissing && (
        <Tooltip title={`缺件 ${missingCount} 件`}>
          <Tag color="error" icon={<MinusCircleOutlined />}>
            缺件{showCount && ` (${missingCount})`}
          </Tag>
        </Tooltip>
      )}
      {hasExtra && (
        <Tooltip title={`超件 ${extraCount} 件`}>
          <Tag color="warning" icon={<PlusCircleOutlined />}>
            超件{showCount && ` (${extraCount})`}
          </Tag>
        </Tooltip>
      )}
      {hasOffList && (
        <Tooltip title={`清单外录入 ${offListCount} 件`}>
          <Tag color="processing" icon={<WarningOutlined />}>
            清单外{showCount && ` (${offListCount})`}
          </Tag>
        </Tooltip>
      )}
    </Space>
  )
}
